import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './MessageScreen.scss';

const MessageScreen = ({ message }) => (
  <div className="MessageScreen">
    <img src="/logo.png" alt="logo" />
    <br />
    { message }
    <br />
    <Link className="Link" href="/" to="/">Home</Link>
  </div>
);

MessageScreen.propTypes = { message: PropTypes.string.isRequired };

export default MessageScreen;
